<template>
	<div class="info-list-container">
		
		<div class="info-header">
			<h3 class="info-title">
				<i :class="iconClass || 'el-icon-menu'"></i> {{ title }}
			</h3>
			<div class="info-opt" @click="$emit('goMore')">
				<span class="more-link">更多 <i class="el-icon-arrow-right"></i></span>
			</div>
		</div>

		<ul class="info-list">
			<li v-for="(item, index) in list" :key="index" class="info-item">
				<span class="cate-tag">{{ item.categoryCName }}</span>
				<router-link :to="{ path: '/infoDetail', query: { id: item.id } }" class="info-title-text">
					{{ item.title }}
				</router-link>
				
				<span class="date-tag">[{{ item.publishTime }}]</span>
			</li>
			<li v-if="list.length === 0" class="empty-item">暂无相关信息</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'InfoList',
		props: {
			title: {
				type: String,
				required: true
			},
			list: {
				type: Array,
				default: () => []
			},
			iconClass: {
				type: String,
				default: 'el-icon-menu'
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info-list-container {
		width: 100%;
		background-color: white;
		border-radius: 5px;
		height: calc(20vh);

		.info-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 8px 15px;
			border-bottom: 1px solid #e6e6e6;

			.info-title {
				margin: 0;
				font-size: 16px;
				color: #009933;

				i {
					margin-right: 8px;
				}
			}

			.info-opt {
				font-size: 12px;
				color: #666;

				.more-link {
					color: #009933;
					cursor: pointer;
				}
			}
		}

		.info-list {
			list-style: none;
			padding: 10px 15px;
			margin: 0;

			.info-item {
				display: flex;
				align-items: center;
				padding: 8px 0;
				border-bottom: 1px dashed #e6e6e6;

				&:last-child {
					border-bottom: none;
				}

				.date-tag {
					font-size: 12px;
					color: #999;
					min-width: 60px;
				}

				.info-title-text {
					flex: 1;
					margin: 0 10px;
					font-size: 14px;
					color: #333;
					text-decoration: none;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;

					&:hover {
						color: #009933;
					}
				}

				.cate-tag {
					font-size: 12px;
					color: #666;
					background-color: #f5f5f5;
					padding: 2px 6px;
					border-radius: 2px;
				}
			}

			.empty-item {
				text-align: center;
				padding: 20px 0;
				color: #999;
				font-size: 14px;
			}
		}
	}
</style>